export interface AssociaDocentiClasse {
    // docenti: Array<DocenteMaterie>;
    docenti: Array<string>;
}

export interface DocenteMaterie {
    docenteId: string;
    materie: Array<string>
}
